import { useEffect, useState } from "react";
import axios from "axios";
import { Spinner } from "@heroui/spinner";

export default function PriceTarget({ stockSymbol }) {
  const [symbol, setSymbol] = useState("");
  const [targetLow, setTargetLow] = useState("");
  const [targetHigh, setTargetHigh] = useState("");
  const [targetMedian, setTargetMedian] = useState("");
  const [targetConsensus, setTargetConsensus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!stockSymbol) return;

    const fetchStockData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          "/api/company/target-price",
          { ticker: stockSymbol },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.status === 200) {
          throw new Error("Network response was not ok");
        }

        const data = await response.data;

        if (data && data.length > 0) {
          const stockInfo = data[0];
          setSymbol(stockInfo.symbol);
          setTargetLow(stockInfo.targetLow);
          setTargetHigh(stockInfo.targetHigh);
          setTargetMedian(stockInfo.targetMedian);
          setTargetConsensus(stockInfo.targetConsensus);
        } else {
          console.error("No data available for the given symbol:", stockSymbol);
        }
      } catch (error) {
        console.error("Error fetching stock data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStockData();
  }, [stockSymbol]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!symbol) {
    return (
      <div className="flex justify-center items-center h-full">
        <div>Not available for this company.</div>
      </div>
    );
  }

  return (
    <div className="p-4  relative">
      <div className="flex justify-between  mb-5">
        <div>
          <h2 className="font-bold text-lg pb-2">Analysts Target Price</h2>
          <div>
            <p className="text-sm">
              Ticker: <span className="font-bold text-sm">{symbol}</span>
            </p>
          </div>
          {/* Ticker symbol displayed here */}
        </div>
        <div>
          <p className="text-right text-lg font-bold">Consensus:</p>
          <p className="text-right">${targetConsensus}</p>
        </div>
      </div>

      <div className="flex mt-10 items-center h-0.5">
        <div className="flex-1 bg-company-profile rounded-full h-full relative">
          {/* Low Target Line */}
          <div className="absolute bg-red-500 rounded-full w-0.5  h-10 left-0"></div>

          {/* Median Target Line */}
          <div className="absolute bg-1B51CA rounded-full w-0.5 h-7 left-1/2 transform -translate-x-1/2"></div>

          {/* High Target Line */}
          <div className="absolute rounded-full 🔹 bg-green-500 w-0.5 h-10 right-0"></div>
        </div>
      </div>
      <div className="flex justify-between">
        <div className="text-sm mt-10">
          <span className="font-bold"> Low: </span>${targetLow}
        </div>
        <div className="text-sm mt-10">
          <span className="font-bold">Mediam: </span> ${targetMedian}
        </div>
        <div className="text-sm  mt-10">
          <span className="font-bold"> High: </span> ${targetHigh}
        </div>
      </div>
    </div>
  );
}
